import React, { useState, useEffect } from 'react';
import './PWAUpdateNotification.css';

const PWAUpdateNotification = () => {
  const [showUpdate, setShowUpdate] = useState(false);
  const [registration, setRegistration] = useState(null);

  useEffect(() => {
    // Listen for service worker updates
    const handleUpdate = (reg) => {
      console.log('[PWA] New version available');
      setRegistration(reg);
      setShowUpdate(true);
    };

    // Check if there's an update available on load
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready.then((reg) => {
        reg.addEventListener('updatefound', () => {
          const newWorker = reg.installing;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              handleUpdate(reg);
            }
          });
        });
      });
    }

    // Listen for custom update event from serviceWorkerRegistration
    const handleServiceWorkerUpdate = (event) => {
      if (event.detail && event.detail.registration) {
        handleUpdate(event.detail.registration);
      }
    };

    window.addEventListener('serviceWorkerUpdate', handleServiceWorkerUpdate);

    return () => {
      window.removeEventListener('serviceWorkerUpdate', handleServiceWorkerUpdate);
    };
  }, []);

  const handleUpdate = () => {
    if (registration && registration.waiting) {
      // Tell the service worker to skip waiting
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      
      // Reload the page to activate the new service worker
      window.location.reload();
    }
  };

  const handleDismiss = () => {
    setShowUpdate(false);
  };

  if (!showUpdate) {
    return null;
  }

  return (
    <div className="pwa-update-notification">
      <div className="pwa-update-content">
        <div className="pwa-update-icon">🔄</div>
        <div className="pwa-update-text">
          <h3>Update Available</h3>
          <p>A new version of PPE SCOPE is available</p>
        </div>
        <div className="pwa-update-actions">
          <button className="pwa-update-btn" onClick={handleUpdate}>
            Update Now
          </button>
          <button className="pwa-update-dismiss-btn" onClick={handleDismiss}>
            Later
          </button>
        </div>
      </div>
    </div>
  );
};

export default PWAUpdateNotification;
